import { Layout } from '@/features/layout/types'
import { useEffect, useState } from 'react'

export const useOrderFinalizationTransitionStep = (layout: Layout): [boolean, () => void] => {
    const [isOpened, setIsOpened] = useState(layout === 'extended')

    useEffect(() => {
        setIsOpened(layout === 'extended')
    }, [layout])

    const toggle = () => setIsOpened((isOpened) => !isOpened)

    return [isOpened, toggle]
}
